<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: shenlin
 * @LastEditTime: 2022-04-28 17:35:54
-->
<template>
  <div class="app-container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="普通机构审核" name="first"><ordinaryListView/></el-tab-pane>
      <el-tab-pane label="服务券机构审核" name="second"><serviceList/></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ordinaryListView from './components/ordinaryList.vue'
import serviceList from './components/serviceList.vue'
export default {
  components: { ordinaryListView, serviceList },
  data() {
    return {
      activeName: 'first'
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.greenColor {
  background: chartreuse;
}
.redColor {
  background: rgb(151, 23, 23);
}
.greyColor {
  background: rgba(49, 48, 48, 0.3);
}
.header {
  display: flex;
  margin-bottom: 20px;
  .header-serach {
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
}
.actcolor {
  color: #1890ff;
}
.nocolor {
  color: rgba(0, 0, 0, 0.3);
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
.sharing-code {
  display: flex;
  span {
    line-height: 34px;
  }
  /deep/.el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  /deep/.el-button--medium {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.exhibition {
  // margin-top: 20px;
  margin-left: -25px;
  display: flex;
  #qrcode {
    width: 125px;
    height: 150px;
    margin: 20px auto;
  }
  .refreshs {
    margin: 20px auto;
    span {
      margin-left: 22px;
    }
    .refresh {
      margin-left: 50px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
.el-popover {
  min-width: 100px !important;
}
</style>
